export default defineNuxtPlugin(async () => {
  const newsDatalessRoutes: string[] = ['/hc'];
  if (newsDatalessRoutes.includes(useRoute().path)) {
    return;
  }

  await useNews().fetchNews();
});
